import React from "react";

const EtWebAdminLeftMenu = ({ activeMenuItem, setActiveMenuItem, menuItems }) => {

  // First Created - 29 Nov 2025
  // Author - Atul Pandey 

  return (
    <div className="w-1/5 bg-white p-3 rounded shadow-lg h-[85vh] overflow-y-auto">

      <p className="text-sm font-bold text-orange-600 mb-3 px-2">
        Admin Menu
      </p>

      {menuItems.map((item, idx) => (
        <div 
          key={item.key}
          onClick={() => setActiveMenuItem(item.key)}
          className={`cursor-pointer px-3 py-2 rounded-md text-sm border-b  my-1
            ${
              activeMenuItem === item.key 
              ? "bg-orange-100 text-orange-700 font-poppins my-1" 
              : "text-gray-600 hover:bg-gray-100"
            }
          `}
        >
          {item.label}
        </div>
      ))}

    </div>
  );
};

export default EtWebAdminLeftMenu;